// FIRST NAME
export const USER_FIRST_NAME_ERR_MSG_LENGTH =
	'First name must be minimum 3 characters and maximum 24 characters';
export const USER_FIRST_NAME_ERR_MSG_NUMBER = 'No numbers are allowed.';
export const USER_FIRST_NAME_ERR_MSG_SYMBOL = `Only allow ",", "-", and "'".`;
export const USER_FIRST_NAME_ERR_MSG_SPACE = `Not allow more than one space between names in a line`;
export const USER_FIRST_NAME_ERR_MSG_EMPTY = 'First name is required.';
// LAST NAME
export const USER_LAST_NAME_ERR_MSG_LENGTH =
	'Last name must be minimum 3 characters and maximum 24 characters';
export const USER_LAST_NAME_ERR_MSG_NUMBER = 'No numbers are allowed.';
export const USER_LAST_NAME_ERR_MSG_SYMBOL = `Only allow ",", "-", and "'".`;
export const USER_LAST_NAME_ERR_MSG_SPACE = `Not allow more than one space between names in a line.`;
export const USER_LAST_NAME_ERR_MSG_EMPTY = 'Last name is required.';
// USERNAME
export const USER_USERNAME_ERR_MSG_LENGTH =
	'Username must be minimum 8 characters and maximum 100 characters';
export const USER_USERNAME_ERR_MSG_SYMBOL = `Only allow dot, dash, underbar, and at sign.`;
export const USER_USERNAME_ERR_MSG_SPACE = `No space is allowed.`;
export const USER_USERNAME_ERR_MSG_EMPTY = 'Username is required.';
// EMAIL
export const USER_EMAIL_ERR_MSG_LENGTH =
	'Email must be minimum 10 characters and maximum 100 characters';
export const USER_EMAIL_ERR_MSG_SYMBOL = 'Only allow dash, at sign, underscore and dot symbols';
export const USER_EMAIL_ERR_MSG_SPACE = 'No space is allowed.';
export const USER_EMAIL_ERR_MSG_FORMAT = 'Invalid email format (ex, text@gmail.com)';
// PHONE
export const USER_PHONE_ERR_MSG_LENGTH = 'Phone must be minimum 10 and maximum 12 numbers';
export const USER_PHONE_ERR_MSG_SYMBOL = 'Only allow dash and dot';
export const USER_PHONE_ERR_MSG_LETTER = 'Not allow letter. (ex. 403-123-4567)';
export const USER_PHONE_ERR_MSG_INVALID = 'Invalid Phone (ex. 403-123-4567)';
// PASSWORD
export const USER_PWD_ERR_MSG_LENGTH =
	'Password must be minimum 8 characters and maximum 30 characters';
export const USER_PWD_ERR_MSG_UPPERCASE = 'Password must be minimum 1 uppercase letter';
export const USER_PWD_ERR_MSG_LOWERCASE = 'Password must be minimum 1 lowercase letter';
export const USER_PWD_ERR_MSG_NUMBER = 'Password must be minimum 1 number';
export const USER_PWD_ERR_MSG_SYMBOL = 'Password must be minimum 1 symbol';
// CONFIRM PASSWORD
export const USER_CONFIRMPWD_ERR_MSG_MATCH = 'Not match password';
export const USER_CONFIRMPWD_ERR_MSG_EMPTY = 'Must be filled up.';
// CUSTOMERS SELECTOR
export const USER_CUSTOMERS_ERR_MSG_EMPTY = 'Must be selected minimum 1 company.';
// CONTACT_TYPES SELECTOR
export const USER_CONTACTTYPES_ERR_MSG_EMPTY = 'Must be selected minimum 1 contact types.';
// USER_ROLES SELECTOR
export const USER_ROLES_ERR_MSG_EMPTY = 'Must be selected minimum 1 user roles.';
/** @deprecated */
export const USER_APPS_ERR_MSG_EMPTY = 'Must be selected minimum 1 app.';
export const USER_ROLES_ERR_MSG_DUPLICATE = 'Must be selected 1 role group.';
// MASTER CUSTOMER
export const USER_MASTER_ERR_MSG_EMPTY = 'Must be selected';
export const PHONE_ERR_MSG = 'Please enter a valid phone number.';
